import { Api } from 'utils';

class ReferralService {

	static get = async (params?: any) => Api.createResponse('client/referrals',params);
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/referrals',params),
		changeStatus: async (params?: any) => Api.createResponse('admin/referrals/change-status',params),
		saveSettings: async (params?: any) => Api.createResponse('admin/referrals/save-settings',params),
	}

}

export default ReferralService;